export default class DtoPluvioMeasureLight {
    constructor(obj, typeId) {
        this.date = obj[0] // DateTime
        this.value = obj[1] // Option[Double]
        this.codepoint = obj[2] // Option[Double]
        this.status = obj[3] // Option[Int]
        this.qualification = obj[4] // Option[Int]
        this.initialPoint = obj[5] // Option[Int]
        this.typeId = typeId
    }
}